(() => {
  const pad = (value) => String(value).padStart(2, '0');

  /**
   * Convert a Europe/Madrid wall-clock time to a UTC instant.
   * A second pass keeps the result correct around daylight-saving changes.
   */
  const madridInstant = (year, month, day, hour, minute) => {
    const timeZone = 'Europe/Madrid';
    const wallClock = (date) => {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-US', {
          timeZone,
          hourCycle: 'h23',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
          .formatToParts(date)
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, part.value])
      );
      return Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute, +parts.second);
    };

    const desired = Date.UTC(year, month - 1, day, hour, minute, 0);
    let instant = desired - (wallClock(new Date(desired)) - desired);
    const wall = wallClock(new Date(instant));
    if (wall !== desired) instant = desired - (wall - desired);
    return instant;
  };

  const initCountdown = (root) => {
    const end = madridInstant(
      Number(root.dataset.year),
      Number(root.dataset.month),
      Number(root.dataset.day),
      Number(root.dataset.hour),
      Number(root.dataset.minute)
    );
    const grid = root.querySelector('[data-cm-grid]');
    const ended = root.querySelector('[data-cm-ended]');
    const status = root.querySelector('[data-cm-status]');
    const fields = {
      days: root.querySelector('[data-cm-days]'),
      hours: root.querySelector('[data-cm-hours]'),
      minutes: root.querySelector('[data-cm-minutes]'),
      seconds: root.querySelector('[data-cm-seconds]'),
    };
    const finish = () => {
      window.clearInterval(timer);
      if (grid) grid.hidden = true;
      if (ended) ended.hidden = false;
      if (status) status.textContent = root.dataset.endedText || '';
    };

    let timer = 0;
    const tick = () => {
      const remaining = end - Date.now();
      if (remaining <= 0) {
        finish();
        return;
      }
      const total = Math.floor(remaining / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      if (fields.days) fields.days.textContent = String(days);
      if (fields.hours) fields.hours.textContent = pad(hours);
      if (fields.minutes) fields.minutes.textContent = pad(minutes);
      if (fields.seconds) fields.seconds.textContent = pad(seconds);
    };

    tick();
    timer = window.setInterval(tick, 1000);
  };

  document.querySelectorAll('[data-cm-countdown]').forEach(initCountdown);

  // Format radios sit outside the product form. Stop the change before it can reach a section listener.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-cm-variant]')) return;
    event.stopPropagation();

    const card = input.closest('[data-cm-card]');
    if (!card) return;

    const idInput = card.querySelector('input[name="id"]');
    const button = card.querySelector('[data-cm-add]');
    const label = card.querySelector('[data-cm-add-label]');
    const price = card.querySelector('[data-cm-price]');
    const unit = card.querySelector('[data-cm-unit]');
    const available = input.dataset.available !== 'false';

    if (idInput instanceof HTMLInputElement) {
      idInput.value = input.value || input.dataset.variantId || '';
      idInput.disabled = !available;
    }
    if (button instanceof HTMLButtonElement) button.disabled = !available;
    if (label && button instanceof HTMLButtonElement) {
      const prefix = button.dataset.labelAdd || '';
      if (!available) {
        label.textContent = button.dataset.labelSold || '';
      } else if (button.hasAttribute('data-cm-priced') && input.dataset.price) {
        label.textContent = `${prefix} — ${input.dataset.price}`;
      } else {
        label.textContent = prefix;
      }
    }
    if (price && input.dataset.price) price.textContent = input.dataset.price;
    if (unit) {
      unit.textContent = input.dataset.unit || '';
      unit.hidden = !input.dataset.unit;
    }
  }, true);

  const closeMenu = (menu) => {
    if (!(menu instanceof HTMLDetailsElement) || !menu.open) return;
    const summary = menu.querySelector('summary');
    const panel = menu.querySelector('[data-cm-panel]');
    menu.open = false;
    if (panel instanceof HTMLElement) panel.hidden = true;
    if (summary instanceof HTMLElement) {
      summary.setAttribute('aria-expanded', 'false');
      if (menu.contains(document.activeElement)) summary.focus();
    }
  };

  const syncMenu = (menu) => {
    if (!(menu instanceof HTMLDetailsElement)) return;
    const summary = menu.querySelector('summary');
    const panel = menu.querySelector('[data-cm-panel]');
    if (summary instanceof HTMLElement) summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    if (panel instanceof HTMLElement) panel.hidden = !menu.open;
  };

  document.querySelectorAll('details.cm-nav__shop, details.cm-shopacc, details.cm-drawer').forEach((menu) => {
    if (!(menu instanceof HTMLDetailsElement)) return;
    syncMenu(menu);
    menu.addEventListener('toggle', () => syncMenu(menu));
  });

  const shopMenu = document.querySelector('details.cm-nav__shop');
  if (shopMenu instanceof HTMLDetailsElement) {
    const hoverQuery = window.matchMedia('(hover: hover) and (min-width: 1000px)');
    let openTimer = 0;
    let closeTimer = 0;
    shopMenu.addEventListener('pointerenter', () => {
      window.clearTimeout(closeTimer);
      if (!hoverQuery.matches || shopMenu.open) return;
      openTimer = window.setTimeout(() => {
        shopMenu.open = true;
      }, 120);
    });
    shopMenu.addEventListener('pointerleave', () => {
      window.clearTimeout(openTimer);
      if (!hoverQuery.matches || !shopMenu.open) return;
      closeTimer = window.setTimeout(() => {
        const summary = shopMenu.querySelector('summary');
        const active = document.activeElement;
        if (active instanceof HTMLElement && shopMenu.contains(active) && active !== summary) return;
        closeMenu(shopMenu);
      }, 260);
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.cm-drawer[open], details.cm-nav__shop[open]').forEach((menu) => {
      closeMenu(menu);
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('details.cm-drawer[open], details.cm-nav__shop[open]').forEach((menu) => {
      if (menu.contains(event.target)) return;
      closeMenu(menu);
    });
  });

  document.querySelector('[data-cm-privacy]')?.addEventListener('click', () => {
    const manage = document.querySelector('#shopify-pc__banner__btn-manage, [data-shopify-privacy-banner-open]');
    if (manage instanceof HTMLElement) {
      manage.click();
      return;
    }
    const banner = document.querySelector('#shopify-pc__banner');
    if (banner instanceof HTMLElement) banner.hidden = false;
  });

  document.querySelectorAll('[data-cm-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-cm-track]');
    if (!(track instanceof HTMLElement)) return;
    const slides = [...track.children];
    const thumbs = [...gallery.querySelectorAll('[data-cm-thumb]')];

    const setCurrent = (index) => {
      thumbs.forEach((thumb, thumbIndex) => {
        if (thumb instanceof HTMLElement) {
          if (thumbIndex === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        }
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!(thumb instanceof HTMLElement)) return;
        const index = Number(thumb.dataset.cmThumb);
        const slide = slides[index];
        if (!(slide instanceof HTMLElement)) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        setCurrent(index);
      });
    });

    track.addEventListener('scroll', () => {
      const width = track.clientWidth || 1;
      setCurrent(Math.round(track.scrollLeft / width));
    }, { passive: true });

    track.addEventListener('keydown', (event) => {
      if (!(event instanceof KeyboardEvent)) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const width = track.clientWidth || 1;
      const current = Math.round(track.scrollLeft / width);
      const next = event.key === 'ArrowRight' ? current + 1 : current - 1;
      const slide = slides[next];
      if (!(slide instanceof HTMLElement)) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      setCurrent(next);
    });
  });

  const scrollPageToTop = () => {
    const wrapper = document.querySelector('.page-wrapper');
    if (window.matchMedia('(min-width: 990px)').matches && wrapper instanceof HTMLElement) {
      wrapper.scrollTo({ top: 0, behavior: 'instant' });
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  const pathOf = (value) => {
    const path = new URL(value, window.location.origin).pathname.replace(/\/+$/, '');
    return path || '/';
  };

  document.querySelectorAll('a.cm-logo').forEach((logo) => {
    logo.addEventListener('click', (event) => {
      if (!(logo instanceof HTMLAnchorElement) || !(event instanceof MouseEvent)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      if (pathOf(logo.href) !== pathOf(window.location.href)) {
        sessionStorage.setItem('cm-home-top', '1');
        return;
      }
      event.preventDefault();
      if (window.location.hash) history.replaceState(history.state, '', pathOf(logo.href));
      scrollPageToTop();
    });
  });

  if (sessionStorage.getItem('cm-home-top') === '1') {
    sessionStorage.removeItem('cm-home-top');
    const pinToTop = () => {
      scrollPageToTop();
      requestAnimationFrame(scrollPageToTop);
    };
    pinToTop();
    window.addEventListener('pageshow', pinToTop);
  }
})();
